import React from "react";

export const AccountContext = React.createContext<any>(null);
